// Announcements — 공지 배너(페이지 scope별) + 전역 공지 팝업.
import { useState, useEffect } from 'react';
import { chatAPI } from '../api/client';

function useAnns() {
  const [anns, setAnns] = useState([]);
  useEffect(() => { chatAPI.getAnnouncements().then((r) => setAnns(r.data || [])).catch(() => {}); }, []);
  return anns;
}
function loadDismissed(key) { try { return JSON.parse(sessionStorage.getItem(key) || '[]'); } catch (e) { return []; } }
// '다시 열지 않기'(영구) — localStorage에 공지 버전키(id:updated_at)로 저장.
// 관리자가 중지→개시하면 updated_at(onupdate)이 바뀌어 키가 달라짐 → 다시 노출.
const PERSIST_KEY = 'dismissedGlobalAnnsPersist';
function loadPersistDismissed() { try { return JSON.parse(localStorage.getItem(PERSIST_KEY) || '[]'); } catch (e) { return []; } }
const annVerKey = (a) => `${a.id}:${a.updated_at || a.created_at || ''}`;

// 기능별 인라인 공지 배너 — scope에 해당하는 활성 공지를 페이지 상단에 표시.
export default function Announcements({ scope }) {
  const anns = useAnns();
  const [dismissed, setDismissed] = useState(() => loadDismissed('dismissedAnns'));
  const dismiss = (id) => { const n = [...dismissed, id]; setDismissed(n); try { sessionStorage.setItem('dismissedAnns', JSON.stringify(n)); } catch (e) {} };
  const list = anns.filter((a) => (a.scope || 'global') === scope && !dismissed.includes(a.id));
  if (!list.length) return null;
  return (
    <>{list.map((a) => (
      <div key={a.id} style={{ background: '#fffbeb', borderBottom: '1px solid #fde68a', padding: '10px 20px', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
        <span style={{ fontSize: '16px', flexShrink: 0 }}>📢</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <span style={{ fontWeight: 700, fontSize: '13px', color: '#92400e', marginRight: '8px' }}>{a.title}</span>
          <span style={{ fontSize: '13px', color: '#78350f', whiteSpace: 'pre-wrap' }}>{a.content}</span>
        </div>
        <button onClick={() => dismiss(a.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#92400e', fontSize: '16px', lineHeight: 1, flexShrink: 0, padding: '0 4px' }}>×</button>
      </div>
    ))}</>
  );
}

// 전체 공지 팝업 — scope=global 활성 공지를 모든 화면 우하단 팝업으로 표시(AppSidebar에서 1회 렌더).
export function GlobalAnnouncementPopup() {
  const anns = useAnns();
  const [dismissed, setDismissed] = useState(() => loadDismissed('dismissedGlobalAnns'));   // 세션 닫기(×)
  const [perma, setPerma] = useState(loadPersistDismissed);                                  // 영구(다시 열지 않기)
  const dismiss = (id) => { const n = [...dismissed, id]; setDismissed(n); try { sessionStorage.setItem('dismissedGlobalAnns', JSON.stringify(n)); } catch (e) {} };
  const dontShowAgain = (a) => { const n = [...perma, annVerKey(a)]; setPerma(n); try { localStorage.setItem(PERSIST_KEY, JSON.stringify(n)); } catch (e) {} };
  const list = anns.filter((a) => (a.scope || 'global') === 'global' && !dismissed.includes(a.id) && !perma.includes(annVerKey(a)));
  const current = list[0];
  useEffect(() => {
    if (!current) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') dismiss(current.id);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [current]);
  if (!current) return null;
  return (
    <div onClick={() => dismiss(current.id)} style={{ position: 'fixed', inset: 0, zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,.5)', padding: '20px' }}>
      <div key={current.id} role="dialog" aria-modal="true" aria-label={current.title} onClick={(e) => e.stopPropagation()} style={{ background: 'white', borderRadius: '12px', boxShadow: '0 8px 30px rgba(0,0,0,.25)', border: '1px solid #fde68a', padding: '16px 18px', color: '#1e1e2e', width: '480px', maxWidth: '92vw', maxHeight: 'calc(100dvh - 40px)', overflowY: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px' }}>
            <span style={{ fontWeight: 700, fontSize: '14px', color: '#92400e', flex: 1, minWidth: 0, whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.4 }}>📢 {current.title}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
              <button onClick={() => dontShowAgain(current)} title="이 공지를 다시 띄우지 않습니다(관리자가 중지 후 다시 개시하면 재표시)"
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '12px', textDecoration: 'underline', padding: 0 }}>다시 열지 않기</button>
              <button onClick={() => dismiss(current.id)} title="닫기(다음 접속 시 다시 표시)" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#92400e', fontSize: '18px', lineHeight: 1, padding: '0 2px' }}>×</button>
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', marginTop: '8px', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{current.content}</div>
      </div>
    </div>
  );
}
